@if (content()) {
  <section data-testid="list-with-heading">
    @if (content().teaserTitle) {
      <h2 class="pr-large-t">
        {{ content().teaserTitle }}
      </h2>
    }
    @for (item of content().items; track $index) {
      <fin-cms-json-content [template$]="{ main: [item] } | finToObservable" />
    }
  </section>
}
